export default __webpack_public_path__ + "static/media/brochure-nep.b513a761.jpg";